<div class="toptext">
    <p>
        E tu che interessi hai?
    </p>
    <div class="iniziativecontainer">
        <mat-card mat-button routerLink="/welcome/ricercatori" class="txtbtn">
            <mat-card-content class="txtbtn-txt">Faccio ricerca</mat-card-content>
        </mat-card>
        <mat-card mat-button routerLink="/welcome/azienda" class="txtbtn">
            <mat-card-content class="txtbtn-txt">Lavoro in azienda</mat-card-content>
        </mat-card>
        <mat-card mat-button routerLink="/welcome/insegnanti" class="txtbtn">
            <mat-card-content class="txtbtn-txt">Insegno</mat-card-content>
        </mat-card>
        <mat-card mat-button routerLink="/welcome/studenti" class="txtbtn">
            <mat-card-content class="txtbtn-txt">Studio</mat-card-content>
        </mat-card>
        <mat-card mat-button routerLink="/welcome/curiosi" class="txtbtn">
            <mat-card-content class="txtbtn-txt">Mi incuriosisce</mat-card-content>
        </mat-card>
    </div>
</div>